import { STATUS_VARIANT_HIGHLIGHT, StatusVariantType } from '@/components/StatusWrapper/const';
import { TaskKindType, TaskMessageKindType, TaskNotifyType, TaskViewType } from '@/types/dashboardTypes';

export const TASK_KINDS: { key: TaskKindType; label: string; sub: string }[] = [
  { key: 'ship', label: 'Ship the order', sub: 'Payment received, fulfilment can start' },
  { key: 'pay', label: 'Make the payment', sub: 'Vendor details received, AP can pay' },
  { key: 'close', label: 'Close the file', sub: 'Nothing else is owed on this transaction' },
  { key: 'custom', label: 'Custom task', sub: 'Describe it in the note' },
];

export const NOTIFY_OPTIONS: { key: TaskNotifyType; label: string }[] = [
  { key: 'both', label: 'Completed and questions' },
  { key: 'done', label: 'Completed only' },
  { key: 'all', label: 'Every update' },
];

export const TASK_VIEWS: { key: TaskViewType; label: string }[] = [
  { key: 'open', label: 'Open' },
  { key: 'question', label: 'Questions' },
  { key: 'done', label: 'Completed' },
  { key: 'all', label: 'All' },
];

export const NOTE_PLACEHOLDER: Record<TaskKindType, string> = {
  ship: 'e.g. Payment for INV-1048 cleared, ship order 4471',
  pay: 'e.g. Vendor bank details verified, pay invoice 2026-311',
  close: 'e.g. Funds received, close file 26-0377',
  custom: 'Describe what should happen next',
};

export const TIMELINE_LABEL: Record<string, string> = {
  assigned: 'Assigned',
  started: 'Started',
  question: 'Question',
  answered: 'Answered',
  completed: 'Completed',
  reassigned: 'Reassigned',
  closed: 'Closed',
};

export const TIMELINE_STATUS_MAP: Record<TaskMessageKindType, StatusVariantType> = {
  assigned: STATUS_VARIANT_HIGHLIGHT.YELLOW,
  started: STATUS_VARIANT_HIGHLIGHT.BLUE,
  question: STATUS_VARIANT_HIGHLIGHT.RED,
  answered: STATUS_VARIANT_HIGHLIGHT.BLUE,
  completed: STATUS_VARIANT_HIGHLIGHT.GREEN,
  reassigned: STATUS_VARIANT_HIGHLIGHT.YELLOW,
  closed: STATUS_VARIANT_HIGHLIGHT.GREY,
  message: STATUS_VARIANT_HIGHLIGHT.GREEN,
} as const;

export const NOTIFICATIONS_POLL_MS = 60000;
